<template>
  <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
              <b-card  header-tag="header" footer-tag="footer">
                  <div slot="header">
                      <!-- <strong> Delivery Dashboard </strong>  -->
                  </div>
                  <b-row>
                      <b-col md="12">

                          <div>
                              <ul class="nav nav-tabs nav-justified" style="border-bottom: unset;margin-bottom: 3%;">
                                  <li class="nav-item">
                                      <button style="width: 80%;" :style="{ 'background-color':  isActiveTab(0) ? '#20a8d8':'' }"  @click="activeTab = 0"  class="nav-link " :class="{'active activeclass' : isActiveTab(0)}">ALL</button>
                                  </li>
                                  <li class="nav-item">
                                      <button style="width: 80%;" :style="{ 'background-color':  isActiveTab(1) ? '#20a8d8':'' }" @click="activeTab = 1"  class="nav-link " :class="{'active activeclass' : isActiveTab(1)}">Pending</button>
                                  </li>
                                  <li class="nav-item">
                                      <button style="width: 80%;" :style="{ 'background-color':  isActiveTab(2) ? '#20a8d8':'' }" @click="activeTab = 2"  class="nav-link " :class="{'active activeclass' : isActiveTab(2)}">Approved</button>
                                  </li>
                                  <li class="nav-item">
                                      <button style="width: 80%;" :style="{ 'background-color':  isActiveTab(3) ? '#20a8d8':'' }" @click="activeTab = 3"  class="nav-link " :class="{'active activeclass' : isActiveTab(3)}">Rejected</button>
                                  </li>
                              </ul>
                          </div>
                          <!-- <div style="float: inline-end;" v-if="activeTab != 4">
                              <b-button variant="success" @click="activeTab = 4"  class="nav-link ">Attendance Report </b-button> 
                          </div> -->
                      </b-col>

                      <b-col md="12">
                          <div class="tab-panel" v-if="isActiveTab(0)">
                              <allrequest style="width:70%;"></allrequest>
                          </div>
                          <div class="tab-panel" v-if="isActiveTab(1)">
                              <pendingrequest style="width:70%;"></pendingrequest>
                          </div>
                          <div class="tab-panel" v-if="isActiveTab(2)">
                                <approvedrequest style="width:70%;"></approvedrequest>
                          </div>
                          <div class="tab-panel" v-if="isActiveTab(3)">
                                <rejectedrequest style="width:70%;"></rejectedrequest>
                          </div>
                          <div class="tab-panel" v-if="isActiveTab(4)">
                                <attendancereport style="width:70%;"></attendancereport>
                          </div>
                          
                      </b-col>
                  </b-row>
              </b-card>
          </b-col>
      </b-row>
     
             
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import allrequest from './requests/allrequest.vue'
import pendingrequest from './requests/pendingrequest.vue'
import approvedrequest from './requests/approvedrequest.vue'
import rejectedrequest from './requests/rejectedrequest.vue'
import attendancereport from './requests/attendancereport.vue'
export default {
  data() {
      return {
          activeTab: 0,
          allrequest,
          pendingrequest,
          approvedrequest,
          rejectedrequest,
          attendancereport,
      }
  },
  components : {
      allrequest,
      pendingrequest,
      approvedrequest,
      rejectedrequest,
      attendancereport,
  },

  created: function() {
      this.isActiveTab(0);
  },

  methods: {
      isActiveTab(id)
      {
      return this.activeTab === id
      },
      attendancereport()
      {

      }
  }
}
</script>


<style scope>
.nav-tabs .nav-link.active .activeclass{
  color: #fff;
  background-color: #20a8d8;
  border-color: #20a8d8;
  border-bottom-color: #fff;
}
/* .nav-tabs .nav-link.active{
  color: #fff;
  background-color: #20a8d8;
  border-color: #20a8d8;
  border-bottom-color: #fff;

} */
</style>
